export const AUTH_REQUEST = 'AUTH_REQUEST';
export const AUTH_LOGINAS = 'AUTH_LOGINAS';
export const AUTH_RETURNAS = 'AUTH_RETURNAS'
export const AUTH_REFRESH = 'AUTH_REFRESH';
export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const AUTH_ERROR = 'AUTH_ERROR';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';
export const OVERRIDE = 'OVERRIDE';

export const BROADCAST_INIT = 'BROADCAST_INIT';
export const BROADCAST_CONNECT = 'BROADCAST_CONNECT';
export const BROADCAST_CONNECTED = 'BROADCAST_CONNECTED';
export const BROADCAST_RECONNECT = 'BROADCAST_RECONNECT';
export const BROADCAST_DISCONNECT = 'BROADCAST_DISCONNECT';
export const BROADCAST_DISCONNECTED = 'BROADCAST_DISCONNECTED';

export const NOTIFICATION_ADD = 'NOTIFICATION_ADD';
export const NOTIFICATION_REMOVE = 'NOTIFICATION_REMOVE';

export const USER_REQUEST = 'USER_REQUEST';
export const USER_SUCCESS = 'USER_SUCCESS';
export const USER_ERROR = 'USER_ERROR';
export const SYNC_USER = 'SYNC_USER';
